<div class="workspace-container px-3">
  <h1 #heading *ngIf="title" [class.mb-0]="isMandatory">{{ title }}</h1>
  <ng-container *ngIf="laasBegrundelse | async as begrundelse">
    <div class="locked-message">
      <svg aria-hidden="true">
        <use xlink:href="#lock"></use>
      </svg>
      <span>{{ begrundelse | tekstresource }}</span>
    </div>
  </ng-container>
  <ng-container *ngIf="isMandatory">
    <p class="error mt-0">Skal udfyldes*</p>
  </ng-container>
  <ng-container *ngIf="isAnySagForaeldet">
    <bom-alert
      type="warning"
      [titleHtml]="'MineProjekter.Projekt.Sag.Foraeldet.Ansoegninstype.Titel' | tekstresource"
      [descriptionHtml]="
        'MineProjekter.Projekt.Sag.Foraeldet.Ansoegninstype.Beskrivelse' | tekstresource
      "
      [showWarningIcon]="true"
    >
    </bom-alert
    ><button class="button button-primary" (click)="openCopyModal()">Kopiér projekt</button>
  </ng-container>
  <p *ngIf="description">{{ description }}</p>
  <ng-content></ng-content>
</div>
